var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "suc-calendar-component",
    {
      attrs: {
        cellData: _vm.cellData,
        isLoading: _vm.isLoading,
        type: _vm.type,
      },
      on: _vm._d({}, [_vm.getCalendarDataEvent, _vm.init]),
      scopedSlots: _vm._u(
        [
          _vm._l(Object.keys(_vm.$scopedSlots), function (slot) {
            return {
              key: slot,
              fn: function (scope) {
                return [_vm._t(slot, null, null, scope)]
              },
            }
          }),
          {
            key: "cell",
            fn: function (props) {
              return [
                _c("planning-calendar-item-component", {
                  attrs: { cell: props.cell },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function (props) {
                          return [
                            _vm._v(" " + _vm._s(props.cell.getValue) + " "),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            },
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._l(Object.keys(_vm.$slots), function (slot) {
        return _vm._t(slot, null, { slot: slot })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }